<template>
    <div class="row">
        <div class="col-12">
            <div class="py-1 bg-white" :class="isInternetAndMobilePack ? 'my-1' : ''">
                <div class="row">
                    <div v-if="dto.offerDiscountTag" class="col-12">
                        <span class="m-1 ob1-tag ob1-tag-primary" v-html="dto.offerDiscountTag" />
                    </div>
                    <div class="col-12">
                        <div class="row px-1">
                            <div class="col-12 px-0">
                                <strong v-if="dto.isDeviceOutOfStock" class="ms-1 ob1-tag ob1-tag-unavailable">Article non disponible</strong>
                                <div class="row px-1">
                                    <div class="col-12 d-flex align-items-md-center" :class="dto.isDeviceOutOfStock ? 'unavailable-item' : ''">
                                        <!--/* VISUEL */-->
                                        <a
                                            v-if="dto.offerDetailsPopinInfo && dto.visual"
                                            href="#"
                                            data-bs-toggle="modal"
                                            :data-bs-target="'#cart-offer-details-' + dto.offerDetailsPopinInfo.idSeo"
                                            data-test-id="btn-popin-detail-offer-image"
                                            @click.prevent="openOffersPopin(dto.offerDetailsPopinInfo)"
                                        >
                                            <div>
                                                <img
                                                    class="responsive-img"
                                                    :alt="dto.visual.alt"
                                                    :src="dto.visual.url"
                                                >
                                            </div>
                                        </a>
                                        <a
                                            v-else-if="dto.offerDetailCta && dto.visual"
                                            :href="dto.offerDetailCta.actionUrl"
                                            :data-oevent-category="dto.offerDetailCta.tmsData.category"
                                            :data-oevent-action="dto.offerDetailCta.tmsData.action"
                                            :data-oevent-label="dto.offerDetailCta.tmsData.label"
                                        >
                                            <div>
                                                <img
                                                    class="responsive-img"
                                                    :alt="dto.visual.alt"
                                                    :src="dto.visual.url"
                                                >
                                            </div>
                                        </a>
                                        <div v-else-if="dto.visual">
                                            <img

                                                class="responsive-img"
                                                :alt="dto.visual.alt"
                                                :src="dto.visual.url"
                                            >
                                        </div>
                                        <!--/* NOM OFFRE + PRIX */-->
                                        <div class="row h-100 w-100 d-flex align-items-center ps-2">
                                            <div class="col-12 col-md-6 px-0">
                                                <ob1-liens
                                                    v-if="dto.offerDetailsPopinInfo"
                                                    class="m-0 ob1-link no-decoration"
                                                    is-button
                                                    data-bs-toggle="modal"
                                                    :modal-id="'cart-offer-details-' + dto.offerDetailsPopinInfo.idSeo"
                                                    :text="dto.offerName"
                                                    @ob1-liens-click="openOffersPopin(dto.offerDetailsPopinInfo)"
                                                />
                                                <a
                                                    v-else-if="dto.offerDetailCta"
                                                    class="m-0 ob1-link no-decoration"
                                                    :href="dto.offerDetailCta.actionUrl"
                                                    :data-oevent-category="dto.offerDetailCta.tmsData.category"
                                                    :data-oevent-action="dto.offerDetailCta.tmsData.action"
                                                    :data-oevent-label="dto.offerDetailCta.tmsData.label"
                                                >
                                                    {{ dto.offerName }}
                                                </a>
                                                <p v-else class="fw-bold m-0">
                                                    {{ dto.offerName }}
                                                </p>
                                                <CartEligibilityInfo
                                                    v-if="formattedAddressInfo"
                                                    :formatted-address-info="formattedAddressInfo"
                                                    class="d-none d-md-flex"
                                                />
                                            </div>
                                            <div class="col-12 col-md-6 d-flex justify-content-md-end text-md-end pe-1">
                                                <div class="row">
                                                    <!--/* PRIX */-->
                                                    <div class="col-12 ps-0">
                                                        <Price
                                                            v-if="dto.price"
                                                            :price="dto.price.price"
                                                            :initial-price="dto.price.initialPrice"
                                                            :price-details="dto.price.priceDetails ? dto.price.priceDetails : undefined"
                                                            :show-from="dto.price.showFrom"
                                                            :show-by-month="dto.price.showByMonth"
                                                            :show-promo-duration="dto.price.showPromoDuration"
                                                            :show-end-of-promotion-price="dto.price.showEndOfPromotionPrice"
                                                            :show-children-promotion-price="dto.price.showChildrenPromotionPrice"
                                                            :show-promo-duration-first-months="dto.price.showPromoDurationFirstMonths"
                                                            :duration="dto.price.duration"
                                                            :is-cents-format="false"
                                                            :is-mini="true"
                                                            :custom="'text-dark'"
                                                        />
                                                    </div>
                                                    <!--/* PROMO REMISE OPEN */-->
                                                    <div v-if="!isInternetAndMobilePack" class="col-12 ps-0">
                                                        <div v-if="dto.discountLabel" class="d-flex justify-content-md-end">
                                                            <div
                                                                class="alert-container alert-container-sm additional-message bg-greige"
                                                            >
                                                                <p class="alert">
                                                                    <span
                                                                        class="alert-icon icon-phone-fund-euro text-primary"
                                                                        aria-hidden="true"
                                                                    />
                                                                    <span
                                                                        class="ob1-alert-title"
                                                                        v-text="dto.discountLabel"
                                                                    />
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <CartEligibilityInfo
                                                        v-if="formattedAddressInfo"
                                                        :formatted-address-info="formattedAddressInfo"
                                                        class="col-12 d-flex d-md-none ps-0"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/* LIENS Modifier / Supprimer */-->
                                    <div class="col-12 pt-1 d-flex justify-content-end text-end">
                                        <div class="d-flex">
                                            <div v-if="dto.modifyOfferCta" class="pe-1">
                                                <a
                                                    class="ob1-link py-0"
                                                    :href="dto.modifyOfferCta.actionUrl"
                                                    :data-oevent-category="dto.modifyOfferCta.tmsData.category"
                                                    :data-oevent-action="dto.modifyOfferCta.tmsData.action"
                                                    :data-oevent-label="dto.modifyOfferCta.tmsData.label"
                                                    v-text="dto.isDeviceOutOfStock ? 'Remplacer ce téléphone' : dto.modifyOfferCta.label"
                                                />
                                            </div>
                                            <div v-if="dto.removeOfferCta" class="ps-1">
                                                <button
                                                    class="ob1-link py-0"
                                                    :data-oevent-category="dto.removeOfferCta.tmsData.category"
                                                    :data-oevent-action="dto.removeOfferCta.tmsData.action"
                                                    :data-oevent-label="dto.removeOfferCta.tmsData.label"
                                                    @click="removeOfferFromCart($event)"
                                                    v-text="dto.removeOfferCta.label"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="dto.offerEquipment" class="col-12 pt-2">
                        <div class="row px-1">
                            <div class="col-12 px-0">
                                <div class="row px-1">
                                    <div class="col-12 d-flex align-items-md-center" :class="dto.isDeviceOutOfStock ? 'unavailable-item' : ''">
                                        <!--/* VISUEL */-->
                                        <a
                                            v-if="dto.offerEquipment.detailCta && dto.offerEquipment.visual"
                                            :href="dto.offerEquipment.detailCta.actionUrl"
                                            :data-oevent-category="dto.offerEquipment.detailCta.tmsData.category"
                                            :data-oevent-action="dto.offerEquipment.detailCta.tmsData.action"
                                            :data-oevent-label="dto.offerEquipment.detailCta.tmsData.label"
                                        >
                                            <div>
                                                <img
                                                    class="responsive-img"
                                                    :alt="dto.offerEquipment.visual.alt"
                                                    :src="dto.offerEquipment.visual.url"
                                                >
                                            </div>
                                        </a>
                                        <div v-else-if="dto.offerEquipment.visual">
                                            <img
                                                class="responsive-img"
                                                :alt="dto.offerEquipment.visual.alt"
                                                :src="dto.offerEquipment.visual.url"
                                            >
                                        </div>
                                        <!--/* NOM OFFRE + PRIX */-->
                                        <div class="row h-100 w-100 d-flex align-items-center ps-2">
                                            <div class="col-12 col-md-6 px-0">
                                                <a
                                                    v-if="dto.offerEquipment.detailCta && dto.offerEquipment.detailCta.actionUrl"
                                                    class="m-0 ob1-link no-decoration"
                                                    :href="dto.offerEquipment.detailCta.actionUrl"
                                                    :data-oevent-category="dto.offerEquipment.detailCta.tmsData.category"
                                                    :data-oevent-action="dto.offerEquipment.detailCta.tmsData.action"
                                                    :data-oevent-label="dto.offerEquipment.detailCta.tmsData.label"
                                                >
                                                    {{ dto.offerEquipment.offerName }}
                                                </a>
                                                <p v-else class="fw-bold m-0">
                                                    {{ dto.offerEquipment.offerName }}
                                                </p>
                                            </div>
                                            <div class="col-12 col-md-6 d-flex justify-content-md-end text-md-end pe-1">
                                                <div class="row">
                                                    <!--/* PRIX */-->
                                                    <div class="col-12 ps-0">
                                                        <Price
                                                            v-if="dto.offerEquipment.price"
                                                            :price="dto.offerEquipment.price.price"
                                                            :initial-price="dto.offerEquipment.price.initialPrice"
                                                            :price-details="dto.offerEquipment.price.priceDetails ? dto.offerEquipment.price.priceDetails : undefined"
                                                            :show-from="dto.offerEquipment.price.showFrom"
                                                            :show-by-month="dto.offerEquipment.price.showByMonth"
                                                            :show-promo-duration="dto.offerEquipment.price.showPromoDuration"
                                                            :show-end-of-promotion-price="dto.offerEquipment.price.showEndOfPromotionPrice"
                                                            :show-promo-duration-first-months="dto.offerEquipment.price.showPromoDurationFirstMonths"
                                                            :duration="dto.offerEquipment.price.duration"
                                                            :is-cents-format="false"
                                                            :is-mini="true"
                                                            :custom="'text-dark'"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/* LIENS Modifier / Supprimer */-->
                                    <div class="col-12 pt-1 d-flex justify-content-end text-end">
                                        <div class="d-flex">
                                            <a
                                                v-if="dto.offerEquipment.modifyCta"
                                                class="ob1-link py-0"
                                                :href="dto.offerEquipment.modifyCta.actionUrl"
                                                :data-oevent-category="dto.offerEquipment.modifyCta.tmsData.category"
                                                :data-oevent-action="dto.offerEquipment.modifyCta.tmsData.action"
                                                :data-oevent-label="dto.offerEquipment.modifyCta.tmsData.label"
                                                v-text="dto.isDeviceOutOfStock ? 'Remplacer ce téléphone' : dto.offerEquipment.modifyCta.label"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="displayOdrDiv" class="col-12 px-2 pt-1">
                        <!--/* PERMANENT ODR MENTION */-->
                        <ul class="row list-unstyled mb-0" aria-label="Offres de remboursement">
                            <li v-for="(odrHtml, odrHtmlIndex) in dto.odrsHtml" :key="'odr-html-without-update-'+odrHtmlIndex">
                                <InlinePromise
                                    :claim="{ attributes: { textHtml: odrHtml } }"
                                    :is-warning="true"
                                    :compact-text="true"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Popin des détails de l'offre (mobile) -->
        <CartOfferDetailsPopin
            v-if="dto.offerDetailsPopinInfo"
            :id="'cart-offer-details-' + dto.offerDetailsPopinInfo.idSeo"
            :cart-offer-details="dto.offerDetailsPopinInfo"
        />
    </div>
</template>
<script>
import Price from "../../components/ob1/Price.vue";
import CartEligibilityInfo from "./CartEligibilityInfo.vue";
import CartOfferDetailsPopin from "../../../fmfmo/acquisition/vitrine/fragments/CartOfferDetailPopin.vue";
import InlinePromise from "../../components/ob1/InlinePromise.vue";

export default {
    name: 'CartPageItem',
    components: {InlinePromise, CartOfferDetailsPopin, CartEligibilityInfo, Price},
    props: {
        dto: {
            type: Object,
            required: true,
        },
        crossSellContent: {
            type: Object,
            required: false,
            default: null
        },
        isInternetAndMobilePack: {
            type: Boolean,
            default: false
        },
        cartOfferDetails: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        displayOdrDiv: function () {
            return this.dto.odrsHtml.length !== 0
        },
        formattedAddressInfo: function () {
            return this.dto?.eligibilityInfo || null;
        },
    },
    methods: {
        removeOfferFromCart(_event) {
            const actionUrl = this.dto.removeOfferCta.actionUrl;
            this.removeItemFromCartInProgress();
            const removeItemFromCartErrorsHandler = this.removeItemFromCartErrorsHandler();
            const removeItemFromCartSuccessHandler = this.removeItemFromCartSuccessHandler();
            $.ajax({
                method: "DELETE",
                url: actionUrl
            })
                .done(removeItemFromCartSuccessHandler)
                .fail(removeItemFromCartErrorsHandler);
            return false;
        },
        removeItemFromCartInProgress() {
            this.$emit('remove-item-from-cart-in-progress')
        },
        removeItemFromCartSuccessHandler() {
            return (response) => {
                this.$emit('remove-item-from-cart-success', response)
            }
        },
        removeItemFromCartErrorsHandler() {
            return (error) => {
                this.$emit('remove-item-from-cart-error', error)
            }
        },
        openOffersPopin(cartOfferDetails) {
            this.$emit('selected-offer-details', cartOfferDetails.name);
        },
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';

.unavailable-item {
    opacity: 0.2
}

.icon {
    font-size: 18px;
}

.gap-1 {
    gap: 15px;
}

.pt-custom {
    padding-top: px-to-rem(7) !important;
}

.responsive-img {
    width: 90px;
}

@media (max-width: 768px) {
    .responsive-img {
        width: 79px;
    }
}
</style>
